import { paths } from '@/constants/paths'
import { RegionContextProvider } from '@/contexts/RegionContext'
import { Seo } from '@/layout/Seo'
import { DefaultLayout } from '@/layouts/DefaultLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getBasePath } from '@/utils/sitemap/base'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GuildVotingView } from '@/views/GuildVotingView'

interface GuildVotingPageProps {
  locale: string
  region: string | null
}

const GuildVotingPage: NextPageWithLayout<GuildVotingPageProps> = ({ locale, region }) => {
  const { t } = useTranslate('guild-voting')
  const basePath = `${getBasePath(locale)}`
  const url = `${basePath}${paths.guild.voting}`
  const title = t('angelGuildVotingTitle', 'Angel Guild Voting | Angel')
  const description = t(
    'angelStudiosGuildVotingDescriptionV2',
    'Watch a torch, cast your vote, and leave feedback for filmmakers as an Angel Guild member. Download the app to start voting.',
  )

  return (
    <>
      <Seo
        canonical={url}
        description={description}
        openGraph={{ title, description, url }}
        path={paths.guild.voting}
        title={title}
      />
      <RegionContextProvider region={region}>
        <GuildVotingView />
      </RegionContextProvider>
    </>
  )
}

GuildVotingPage.getLayout = (page) => {
  return <DefaultLayout>{page}</DefaultLayout>
}

export const getServerSideProps = getServerSidePropsErrorHandler<GuildVotingPageProps>(async ({ locale, region }) => {
  return {
    props: {
      locale,
      region,
      ...(await loadTranslations(locale, ['common', 'guild-voting', 'app-promo', 'watch'])),
    },
  }
})

export default GuildVotingPage
